import { useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router-dom';

import { PatientsTabNav } from '@/components/patients/PatientsTabNav';
import { findPatientsTab, PATIENTS_TABS } from '@/lib/patients/patientsTabs';

/**
 * The Patients section: a heading naming the active tab, the tab bar, and the tab's own page in the
 * outlet. The active tab comes from the URL, so it survives reloads and deep links.
 */
export function PatientsPage() {
  const { t } = useTranslation('providers');
  const segment = useMatch('/patients/:tab/*')?.params.tab;
  // Bare /patients and unknown tabs have no matching tab for the one render before their redirect
  // lands, so they briefly show the default tab rather than nothing.
  const active = findPatientsTab(segment) ?? PATIENTS_TABS[0];

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-h2 font-semibold tracking-tight text-foreground">{t(active.labelKey)}</h1>

      <PatientsTabNav active={active.id} />

      <Outlet />
    </div>
  );
}
